import { ComponentStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps } from '@chakra-ui/theme-tools';

import { PageHeaderProps } from './PageHeader';

import COLORS from 'theme/colors';

const PageHeaderTheme: ComponentStyleConfig = {
  baseStyle: (props: PageHeaderProps & StyleFunctionProps) => ({
    display: 'flex',
    borderBottom: props.showBorder ? '1px' : undefined,
    borderColor: COLORS.silver.base,
    paddingBottom: '16px'
  })
};

export default PageHeaderTheme;
